import * as THREE from 'three';

const GAITS = new Set(['pose_stand', 'pose_walk', 'pose_jog', 'pose_run']);
const smooth = t => { const x = Math.min(1, Math.max(0, t)); return x * x * (3 - 2 * x); };

/** Sample full-body gestures from timeline time, including seeking and repeats.
 * Base gaits keep their phase underneath, with complementary blend weight.
 */
export function sampleCharacterAction(ud, keys, time) {
    const { mixer, clips = [] } = ud;
    if (!mixer) return;
    const overlays = ud.timelineActions || (ud.timelineActions = new Map());
    let active = null;
    for (const key of keys) {
        const name = key.type || key.value;
        if (GAITS.has(name) || name === 'pose_t') continue;
        const clip = clips.find(c => c.name === name);
        const elapsed = time - Number(key.time);
        if (!clip || !Number.isFinite(elapsed) || elapsed < 0 || elapsed >= clip.duration + 0.16) continue;
        if (!active || Number(key.time) >= Number(active.key.time)) active = { key, name, clip, elapsed };
    }
    let weight = 0;
    if (active) {
        weight = smooth(active.elapsed / 0.08) * (1 - smooth((active.elapsed - active.clip.duration) / 0.16));
        let action = overlays.get(active.name);
        if (!action) { action = mixer.clipAction(active.clip); overlays.set(active.name, action); }
        action.stopFading();action.enabled = true;action.paused = true;
        action.setLoop(THREE.LoopOnce, 1);action.clampWhenFinished = true;
        action.time = Math.min(active.elapsed, active.clip.duration);
        action.setEffectiveWeight(weight);action.play();
    }
    for (const [name, action] of overlays) {
        if (name !== active?.name) { action.stop();action.setEffectiveWeight(0); }
    }
    // Preserve any gait crossfade interpolants while changing their base weight.
    // setEffectiveWeight() would cancel those interpolants every frame.
    for (const clip of clips) {
        if (GAITS.has(clip.name)) {
            const action = mixer.existingAction(clip);
            if (action) action.weight = 1 - weight;
        }
    }
}
